import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import moment from "moment";
import { Spin, Empty } from "antd";
import { HiOutlineBell, HiOutlineClock, HiOutlineChevronLeft, HiOutlineUser } from 'react-icons/hi';
import Cookies from "js-cookie";

function NotificationComponent() {
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [notifications, setNotifications] = useState([]);
    const [doctorInfo, setDoctorInfo] = useState(null);

    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        setLoading(true);
        try {
            const doctorId = Cookies.get("doctor_id") || Cookies.get("Doctor_id") || localStorage.getItem("Doctor_id");
            const clinicId = Cookies.get("clinic_id") || Cookies.get("Clinic_id") || localStorage.getItem("clinic_id");
            const specialityId = Cookies.get("speciality_Id") || localStorage.getItem("speciality_Id");

            const [docRes, notifyRes] = await Promise.allSettled([
                axiosInstance.post("clinic/getClinicWiseDoctor", { clinic_id: clinicId }),
                axiosInstance.post("doctor/doctorwebnotification", {
                    doctor_id: doctorId,
                    clinic_id: clinicId,
                    speciality_id: specialityId
                })
            ]);

            if (docRes.status === 'fulfilled' && docRes.value.data?.status === 1) {
                const docList = docRes.value.data.data || [];
                const doc = docList.find(x => String(x.doctor_id) === String(doctorId)) || docList[0];
                setDoctorInfo(doc);
            }

            if (notifyRes.status === 'fulfilled' && notifyRes.value.data?.status === 1) {
                setNotifications(notifyRes.value.data.data || []);
            } else {
                setNotifications([]);
            }
        } catch (error) {
            console.error("Failed to fetch notification data", error);
            setNotifications([]);
        } finally {
            setLoading(false);
        }
    };

    const convertTo12HrFormat = (time24) => {
        if (!time24) return '--:--';
        return moment(time24, 'HH:mm:ss').format('hh:mm A');
    };

    return (
        <div className="space-y-3 animate-in fade-in duration-300 w-full text-gray-800">
            {/* Integrated Header Bar */}
            <div className="bg-white px-3.5 py-2.5 rounded-lg border border-gray-200 shadow-2xs flex items-center justify-between gap-2.5 text-left w-full">
                <div className="flex items-center gap-2.5 text-left shrink-0">
                    <button 
                        onClick={() => history.push("/dashboard")}
                        className="p-1 hover:bg-gray-100 rounded text-gray-400 hover:text-gray-700 transition-colors cursor-pointer flex items-center justify-center shrink-0"
                        title="Back to Dashboard"
                    >
                        <HiOutlineChevronLeft size={18} />
                    </button>
                    <div className="text-left">
                        <h2 className="text-sm font-bold text-gray-800 leading-tight text-left m-0">Notifications</h2>
                        <p className="text-gray-400 text-[11px] text-left m-0 mt-0.5">Stay updated with your latest clinic activities</p>
                    </div>
                </div>
                {doctorInfo && (
                    <div className="bg-teal-50 border border-teal-100 text-teal-700 px-2.5 py-1 rounded-lg font-bold text-xs flex items-center gap-1.5 shrink-0 ml-auto">
                        <HiOutlineUser size={14} />
                        <span>{doctorInfo.doctorName}</span>
                    </div>
                )}
            </div>

            {/* Notification List */}
            <div className="space-y-2">
                {loading ? (
                    <div className="py-10 flex flex-col items-center justify-center gap-2 bg-white rounded-lg border border-gray-200">
                        <Spin size="small" />
                        <p className="text-gray-400 font-semibold text-xs">Loading notifications...</p>
                    </div>
                ) : notifications.length > 0 ? (
                    notifications.map((item, i) => (
                        <div 
                            key={i} 
                            className="bg-white p-3 sm:p-3.5 rounded-lg border border-gray-200 shadow-2xs hover:shadow-xs transition-all flex items-start gap-3"
                        >
                            <div className="bg-teal-50 p-2 rounded-md text-teal-600 shrink-0 border border-teal-100">
                                <HiOutlineBell size={18} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex items-center justify-between gap-2 mb-1">
                                    <h4 className="font-bold text-xs text-gray-800 truncate">{item.vendor_name || 'System Update'}</h4>
                                    <div className="flex items-center gap-1 text-gray-400 text-[10px] font-semibold uppercase tracking-wider shrink-0">
                                        <HiOutlineClock size={12} />
                                        <span>{convertTo12HrFormat(item.booked_time)}</span>
                                    </div>
                                </div>
                                <p className="text-gray-600 text-xs leading-relaxed mb-2">
                                    {item.notification_content}
                                </p>
                                <div className="flex items-center gap-2 text-[10px] font-semibold text-gray-400 uppercase tracking-wider">
                                    <span>{item.vendor_contact || 'Clinic System'}</span>
                                    {item.to_date && (
                                        <>
                                            <span className="w-1 h-1 bg-gray-300 rounded-full" />
                                            <span>{moment(item.to_date).format('DD MMM YYYY')}</span>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="bg-white py-8 rounded-lg border border-dashed border-gray-200 flex flex-col items-center">
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span className="text-xs font-medium text-gray-400">You're all caught up! No new notifications</span>} />
                    </div>
                )}
            </div>
        </div>
    );
}

export default NotificationComponent;
